import React from 'react';
import { CustomNoRowsOverlayProps } from '@ag-grid-community/react';
import styles from './NoRowsOverlay.styles';
import { NoRowsOverlayConfig } from 'configuration-schemas/viewdefns/general';
import { Link } from 'react-router';
import EditableOverlay from 'src/components/EditableOverlay/EditableOverlay.container';

export const NoRowsOverlay = () => {
  return <div className={styles.noDataOverlay}>No Data</div>;
};

interface GridNoRowsOverlayProps extends CustomNoRowsOverlayProps {
  noRowsOverlayConfig: NoRowsOverlayConfig;
}

export const GridNoRowsOverlay = ({ noRowsOverlayConfig }: GridNoRowsOverlayProps) => {
  switch (noRowsOverlayConfig?.type) {
    case 'EditableOverlay':
      return <EditableOverlay configApi={noRowsOverlayConfig.configApi} />;
    case 'EmptyWorklistLink':
      return (
        <div className={styles.noDataOverlay}>
          This view is for your worklist items. Add items to you worklist
          <Link to={noRowsOverlayConfig.path ?? ''} className={styles.noDataOverlayLink}>
            here
          </Link>
        </div>
      );
    case 'EmptyTopMember':
      return (
        <div className={styles.noDataOverlay}>
          This view is for viewing Breadcrumb items. Please go
          <Link to={noRowsOverlayConfig.path ?? ''} className={styles.noDataOverlayLink}>
            here
          </Link>
          to select one.
        </div>
      );
    default:
      return <NoRowsOverlay />;
  }
};
